import React from 'react';
import FilePreview from './FilePreview';

const FilePreviews = ({ files }: { files: FileList | null }): JSX.Element | null => {
  if (files === null || files.length === 0) {
    return null;
  }
  return (
    <>
      {Array.from(files)
        .filter(Boolean)
        .map((file) => (
          <FilePreview key={file.name} file={file} />
        ))}
    </>
  );
};

export default FilePreviews;
